export default __webpack_public_path__ + "static/media/L5.bcfd3232.webp";